import React from 'react';
import AboutHero from '../components/about/AboutHero';
import OurMission from '../components/about/OurMission';
import WhoWeAre from '../components/about/WhoWeAre';
import PartnerSection from '../components/about/PartnerSection';
import OurCapabilities from '../components/about/OurCapabilities';
import AboutContactForm from '../components/about/AboutContactForm';
import TeamSection from '../components/careers/TeamSection';

const About: React.FC = () => {
  return (
    <div className="w-full bg-white">
      <AboutHero />
      <OurMission />
      <PartnerSection />
      <WhoWeAre />
      <TeamSection categories={['Founder & CEO']} />
      <OurCapabilities />
      <AboutContactForm />
    </div>
  );
};

export default About;
